import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-person-add-edit',
  templateUrl: './person-add-edit.component.html',
  styleUrls: ['./person-add-edit.component.scss']
})
export class PersonAddEditComponent implements OnInit {

  @Input() object: any;
  @Input() key: any;
  @Input() extraData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
